export const SET_CURRENT_MODEL = 'setCurrentModel';
export const SET_CURRENT_MODEL_DATA = 'setCurrentModelData';
